/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(_initialState: any | undefined) {
  return {
    canAdmin: false,
  };
}
